import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../../api/client';
import ViewResult from '../../component/ViewResult';

export default function CandidateResultPage() {
    const { id, sessionId } = useParams();
    const navigate = useNavigate();
    const [feedback, setFeedback] = useState(null);
    const [sessionData, setSessionData] = useState(null);
    const [loadingFeedback, setLoadingFeedback] = useState(true);
    const [feedbackError, setFeedbackError] = useState('');

    const fetchResult = useCallback(async () => {
        if (!sessionId) return;
        setLoadingFeedback(true);
        setFeedbackError('');
        setFeedback(null);
        setSessionData(null);
        try {
            const sessionRes = await api.get(`sessions/${sessionId}/`);
            let data = sessionRes.data;
            setSessionData(data);
            const res = await api.get(`feedback/?session=${sessionId}`);
            if (!res.data?.results?.length) {
                setFeedbackError('No feedback found for this session.');
                return;
            }
            setFeedback(res.data.results[0]);
        } catch (err) {
            setFeedbackError('Failed to load feedback.');
            console.error('Error loading feedback:', err);
        } finally {
            setLoadingFeedback(false);
        }
    }, [sessionId]);

    useEffect(() => {
        fetchResult();
    }, [fetchResult]);

    const handleClose = () => navigate(`/candidatedetails/${id}`);

    return (
        <div className="min-h-screen bg-gray-100">
            <ViewResult
                feedback={feedback}
                loadingFeedback={loadingFeedback}
                feedbackError={feedbackError}
                onClose={handleClose}
                sessionData={sessionData}
                emailSent={false}
                isSendingEmail={false}
                sendEmail={undefined}
                callFrom="candidateResultPage"
                isPage={true}
            />
        </div>
    );
}
